import React from 'react';

import CommonImage from '@components/CommonImage';

const ModalHeader = ({ title, subTitle, onClose, extraClass = '' }) => {
	return (
		<div className={`common-popup-header d-flex justify-content-between ${extraClass}`}>
			<div className="popup-tilte">
				<h3 className="semibold-16 mb-0">{title}</h3>
				{subTitle && <p className="regular-10 gray_dark_03">{subTitle}</p>}
			</div>
			<div className="close-btn" onClick={onClose}>
				<CommonImage src="/icons/close.svg" alt="close" isStatic={true} />
			</div>
		</div>
	);
};

export default ModalHeader;
